import React from "react"
import {
  NavItem,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
} from "reactstrap"
import axios from "axios"
import * as Icon from "react-feather"
import { history } from "../../../history"
import { connect } from "react-redux"
import { theme } from "react-treebeard"

const UserDropdown = props => {
  return (
    <DropdownMenu right>
      {/*}<DropdownItem tag="a" href="#">
        <Icon.User size={14} className="mr-50" />
        <span className="align-middle">Edit Profile</span>
      </DropdownItem>
      <DropdownItem tag="a" href="#">
        <Icon.Mail size={14} className="mr-50" />
        <span className="align-middle">My Inbox</span>
      </DropdownItem>
      <DropdownItem tag="a" href="#">
        <Icon.CheckSquare size={14} className="mr-50" />
        <span className="align-middle">Tasks</span>
      </DropdownItem>
      <DropdownItem tag="a" href="#">
        <Icon.MessageSquare size={14} className="mr-50" />
        <span className="align-middle">Chats</span>
      </DropdownItem>
      <DropdownItem tag="a" href="#">
        <Icon.Heart size={14} className="mr-50" />
        <span className="align-middle">WishList</span>
      </DropdownItem>{*/}
      <DropdownItem divider />
      <DropdownItem
        tag="a"
        onClick={e => {history.push("/login");props.reset_logout();localStorage.clear();}}
      >
        <Icon.Power size={14} className="mr-50" />
        <span className="align-middle" >Cerrar sesión</span>
      </DropdownItem>
    </DropdownMenu>
  )
}

class NavbarUser extends React.PureComponent {
  state = {
    navbarSearch: false,
    suggestions: []
  }

  componentDidMount() {
    axios.get("/api/main-search/data").then(({ data }) => {
      this.setState({ suggestions: data.searchResult })
    })
  }

  handleNavbarSearch = () => {
    this.setState({
      navbarSearch: !this.state.navbarSearch
    })
  }

  render() {
    return (
      <ul className="nav navbar-nav navbar-nav-user float-right">
        <NavItem className="nav-search" onClick={this.handleNavbarSearch}>
        </NavItem>
        <UncontrolledDropdown
          tag="li"
          className="dropdown-notification nav-item"
        >
          <DropdownToggle
            tag="a"
            className="nav-link position-relative"
            onClick={() => this.props.changeMode("dark")}
          >
            <Icon.Moon size={21} />
          </DropdownToggle>
        </UncontrolledDropdown>
        <UncontrolledDropdown
          tag="li"
          className="dropdown-notification nav-item"
        >
          <DropdownToggle
            tag="a"
            className="nav-link position-relative"
            onClick={() => this.props.changeMode("light")}
          >
            <Icon.Sun size={21} />
          </DropdownToggle>
        </UncontrolledDropdown>

        <UncontrolledDropdown tag="li" className="dropdown-user nav-item">
          <DropdownToggle tag="a" className="nav-link dropdown-user-link">
            <div className="user-nav d-sm-flex d-none">
              <span className="user-name text-bold-600">
                {this.props.userName}
              </span>
              <span className="user-status">{this.props.userEmail}</span>
            </div>
            <span data-tour="user">
              <img
                src={this.props.userImg}
                className="round"
                height="40"
                width="40"
                alt="avatar"
              />
            </span>
          </DropdownToggle>
          <UserDropdown {...this.props} />
        </UncontrolledDropdown>
      </ul>
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    reset_logout: () => {
      dispatch({type:"RESET_LOGOUT"});
    },
    changeMode: (mode) => {
      localStorage.setItem("theme",mode);
      dispatch({type:"CHANGE_MODE",mode});
    }
  }
}

export default connect(null,mapDispatchToProps)(NavbarUser)
